import './Languages.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

import { LANGUAGES } from '../../js/_constants';
import Flag from '../flag/Flag';

const Languages = ({ setShowLanguages }) => {
    const { i18n } = useTranslation();

    let currentLanguageCode = i18n.language;
    const languageCodes = LANGUAGES.map(lang => lang.code);

    if (!languageCodes.includes(currentLanguageCode)) {
        currentLanguageCode = 'en';
    }

    return (
            <div className="b-languages">
                <ul className="languages-menu">
                    {LANGUAGES.map(({ code, name, country_code }) => (
                        <li key={country_code} className="language-option">
                            <button
                                className={classnames('language', {
                                    selected: currentLanguageCode === code
                                })}
                                onClick={() => {
                                    i18n.changeLanguage(code);
                                    setShowLanguages(false);
                                }}
                                disabled={currentLanguageCode === code}
                                data-testid={`language-${code}`}
                            >
                                <Flag
                                    key={country_code}
                                    country={country_code}
                                />
                                {name}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
    );
};

export default Languages;
